export default __webpack_public_path__ + "static/media/blog-img-2.60080aed.png";